import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireManager?: boolean
}

export default function ProtectedRoute({ children, requireManager = false }: ProtectedRouteProps) {
  const { isAuthenticated, isManager, isLoading } = useAuthStore()
  const location = useLocation()

  // Show loading state while checking auth - prevents flash of unauthorized content
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-20 h-20 rounded-2xl bg-primary flex items-center justify-center mb-2 p-3">
            <img
              src="/assets/GHP Logo White heart.svg"
              alt="GH Pharmacy"
              className="w-full h-full object-contain"
            />
          </div>
          <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-muted-foreground">Verifying access...</p>
        </div>
      </div>
    )
  }

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Requires manager but user is not a manager
  if (requireManager && !isManager) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-danger mb-2">Access Denied</h1>
          <p className="text-muted-foreground">You don't have permission to access this page.</p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
